var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "white",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.9345 23.6385C13.7201 23.8531 13.5996 24.144 13.5996 24.4473C13.5996 24.7506 13.7201 25.0415 13.9345 25.256L14.7432 26.0647C14.9577 26.2792 15.2486 26.3996 15.5519 26.3996C15.8553 26.3996 16.1461 26.2792 16.3607 26.0647L19.9996 22.4258L17.5734 19.9996L13.9345 23.6385ZM26.0647 14.7432L25.256 13.9345C25.0415 13.7201 24.7506 13.5996 24.4473 13.5996C24.144 13.5996 23.8531 13.7201 23.6385 13.9345L19.9996 17.5734L22.4258 19.9996L26.0647 16.3607C26.2792 16.1461 26.3996 15.8553 26.3996 15.5519C26.3996 15.2486 26.2792 14.9577 26.0647 14.7432Z",
    fill: "#335C75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0647 23.6385C26.2792 23.8531 26.3996 24.144 26.3996 24.4473C26.3996 24.7506 26.2792 25.0415 26.0647 25.256L25.256 26.0647C25.0415 26.2792 24.7506 26.3996 24.4473 26.3996C24.144 26.3996 23.8531 26.2792 23.6385 26.0647L13.9345 16.3607C13.7201 16.1461 13.5996 15.8553 13.5996 15.5519C13.5996 15.2486 13.7201 14.9577 13.9345 14.7432L14.7432 13.9345C14.9577 13.7201 15.2486 13.5996 15.5519 13.5996C15.8553 13.5996 16.1461 13.7201 16.3607 13.9345L26.0647 23.6385Z",
    fill: "#335C75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4258 19.9996L26.0647 16.3607C26.5112 15.9142 26.5112 15.1902 26.0647 14.7432L25.256 13.9345C24.8094 13.488 24.0854 13.488 23.6385 13.9345L19.9996 17.5734L16.3607 13.9345C15.9142 13.488 15.1902 13.488 14.7432 13.9345L13.9345 14.7432C13.488 15.1898 13.488 15.9138 13.9345 16.3607L17.5734 19.9996L13.9345 23.6385C13.488 24.0851 13.488 24.8091 13.9345 25.256L14.7432 26.0647C15.1898 26.5112 15.9142 26.5112 16.3607 26.0647L19.9996 22.4258L23.6385 26.0647C24.0851 26.5112 24.8094 26.5112 25.256 26.0647L26.0647 25.256C26.5112 24.8094 26.5112 24.0854 26.0647 23.6385L22.4258 19.9996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close_white.07eb192fc234edcdd0a8bcf7ba8ea2b1.svg";
export { ForwardRef as ReactComponent };